export function compose(...args) {
  const lastIndex = args.length - 1;

  return x => {
    let result = x;

    for (let i = lastIndex; i >= 0; i -= 1) {
      result = args[i](result);
    }

    return result;
  };
}
